// extracted by mini-css-extract-plugin
export default {"elementPlaceholder":"A4dTM_Y6W_hpqoTHpBGN"};